import { useEffect } from 'react';
import { usePayPalScriptReducer, PayPalButtons } from '@paypal/react-paypal-js';
import { toast } from 'react-toastify';
import {
  usePayOrderMutation,
  useGetPaypalClientIdQuery,
} from '../slices/ordersApiSlice';

export const usePayPalCheckout = (orderId, totalPrice, refetch) => {
  const [{ isPending }, paypalDispatch] = usePayPalScriptReducer();

  const [payOrder, { isLoading: loadingPay }] = usePayOrderMutation();

  const { data: paypalConfig } = useGetPaypalClientIdQuery();
console.log('paypalConfig:', paypalConfig);
console.log('orderId:', orderId);
  // Load PayPal SDK
  useEffect(() => {
    if (!paypalConfig?.clientId) return;

    paypalDispatch({
      type: 'resetOptions',
      value: {
        'client-id': paypalConfig.clientId,
        currency: 'USD',
      },
    });

    paypalDispatch({
      type: 'setLoadingStatus',
      value: 'pending',
    });
  }, [paypalConfig, paypalDispatch]);

  // Create PayPal order
  const createOrder = (data, actions) => {
    console.log('paypalConfig:', paypalConfig);
console.log('orderId:', orderId);
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: totalPrice.toString(),
          },
        },
      ],
    });
  };

  // Handle approval (CLEAN VERSION)
  const onApprove = async (data, actions) => {
    try {
      const details = await actions.order.capture();

      const payload = {
        orderId,
        id: details.id,
        status: details.status,
        update_time: details.update_time,
        payer: {
          email_address: details?.payer?.email_address || '',
        },
      };

      await payOrder({
  orderId,
  details: {
    id: details.id,
    status: details.status,
    update_time: details.update_time,
    payer: details.payer,
  },
}).unwrap();

      await refetch();

      toast.success('Payment successful');
    } catch (err) {
      toast.error(err?.data?.message || err.message || 'Payment failed');
    }
  };

  // Handle errors
  const onError = (err) => {
    toast.error(err?.message || 'PayPal error occurred');
  };

  // Button component
  const PayPalButtonWrapper = () => (
    <PayPalButtons
      createOrder={createOrder}
      onApprove={onApprove}
      onError={onError}
      disabled={isPending || loadingPay}
    />
  );

  return {
    PayPalButtonWrapper,
    isPending,
    loadingPay,
  };
};